import React from "react";
import Image from '../components/image/Image.js';
import styles from "./Figure.module.css";

function Figure(props) {
  return (
    <figure className={styles.simplefigure}>
      <Image loading="lazy" src={props.src} alt="Imagem"></Image>
    </figure>
  );
}

export default Figure;
